// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import BootstrapVue from 'bootstrap-vue'

import jQuery from 'jquery'
import router from './router'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr'
import VueI18n from 'vue-i18n'
import Toasted from 'vue-toasted'
import VuePageTransition from 'vue-page-transition'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBath, faMap, faUser, faFileAlt, faList, faSync, faDollarSign, faBorderAll, faSquare, faArchive, faDoorClosed, faUndo, faTrash, faSave, faTimes, faClone, faEdit, faFolder, faPlus, faEye, faIdBadge, faSignInAlt, faSignOutAlt, faAngleLeft, faAngleRight  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

if (process.env.NODE_ENV === "production") {
  Vue.prototype.$url_name = 'https://plomberieparadis.com/api/v1'
  Vue.prototype.$host_name = 'https://plomberieparadis.com'
} else {
  Vue.prototype.$url_name = 'http://localhost:8000/api/v1'
  Vue.prototype.$host_name = 'http://localhost:8000'
}

library.add(faBath)
library.add(faMap)
library.add(faUser)
library.add(faFileAlt)
library.add(faList)
library.add(faSync)

library.add(faDollarSign)
library.add(faFolder)
library.add(faPlus)
library.add(faBorderAll)
library.add(faSquare)
library.add(faArchive)
library.add(faDoorClosed)
library.add(faUndo)
library.add(faTrash)
library.add(faSave)
library.add(faEye)
library.add(faIdBadge)
library.add(faSignInAlt)
library.add(faSignOutAlt)
library.add(faEdit)
library.add(faTimes)
library.add(faClone)
library.add(faAngleLeft)
library.add(faAngleRight)

global.jQuery = jQuery

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(BootstrapVue)
Vue.use(Toasted)
Vue.use(VuePageTransition)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'fr'
})

Vue.use(VeeValidate, {
  i18n,
  dictionary: {
    fr
  }
})

Vue.prototype.$user_name = ''
Vue.prototype.$userId = ''
Vue.prototype.$soumissionId = ''

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js